import React from "react";
import { ROUNDS } from "../../../constants/secondaryCamera";

const EndedScreen = ({ candidateName, round }) => {
  const isInterview = round === ROUNDS.INTERVIEW;
  return (
    <div className="min-h-screen app-background py-12 px-4 sm:px-6 lg:px-8 animate-gradient-x">
      <div className="max-w-4xl mx-auto">
        <div className="text-center my-16 animate-fade-in">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center animate-pulse">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
          </div>
          <h1 className="text-4xl font-semibold tracking-tight bg-gradient-to-r from-[#2960FD] to-[#FF60B6] text-transparent bg-clip-text mb-6">
            {isInterview ? "Interview Complete!" : "Monitoring Complete"}
          </h1>
          <div className="space-y-4 max-w-2xl mx-auto">
            {candidateName && (
              <h3 className="text-xl text-gray-200 leading-relaxed">
                {isInterview ? (
                  <>The interview for <span className="font-medium">{candidateName}</span> has been completed.</>
                ) : (
                  <>This round's monitoring for <span className="font-medium">{candidateName}</span> is done.</>
                )}
              </h3>
            )}
            <p className="text-gray-400 text-base leading-relaxed">
              Secondary camera monitoring is no longer needed for this session.
            </p>
            <p className="text-gray-500 text-sm mt-6">You can now close this tab.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EndedScreen;
